import React, { FC, useState } from 'react';
import clsx from 'clsx';
import { Button } from '@marriott/mi-ui-library';
import { NavigationMenuMobileProps } from './NavigationMenuMobile.types';
import {
  StyledNavigationMenuWrapper,
  StyledNavigationMenu,
  StyledActiveMenuContainer,
  StyledActiveMenu,
  StyledMainMenu,
  StyledMainMenuItems,
  StyledMainMenuItem,
  StyledSubMenuWithBackCta,
  StyledBackCtaContainer,
  StyledBackCta,
  StyledMainMenuTitle,
  StyledSubMenuContainer,
  StyledSubMenu,
  StyledSubMenuItem,
} from './NavigationMenuMobile.styles';

export const NavigationMenuMobile: FC<NavigationMenuMobileProps> = ({
  sectionNavigationItems = [],
  activeMenuItem,
  navigationAriaLabel,
  trackingProperties,
  dir = 'ltr',
  hideNavItemArrow,
}) => {
  const [selectedMenuIndex, setSelectedMenuIndex] = useState<number | null>(null);
  const [showNavigationMenu, setShowNavigationMenu] = useState(false);

  const toggleNavigationMenu = () => {
    if (!showNavigationMenu) {
      document.body.classList.add('no-overflow');
    } else {
      document.body.classList.remove('no-overflow');
    }
    setShowNavigationMenu(!showNavigationMenu);
  };

  return (
    <StyledNavigationMenuWrapper data-testid="navigation-menu-mobile">
      <StyledNavigationMenu>
        <StyledActiveMenuContainer>
          <StyledActiveMenu aria-expanded="false" onClick={() => toggleNavigationMenu()} data-testid="active-menu">
            <span>{activeMenuItem.title}</span>
            {showNavigationMenu ? (
              <span className="icon-dropdown-up"></span>
            ) : (
              <span className="icon-dropdown-down"></span>
            )}
          </StyledActiveMenu>
        </StyledActiveMenuContainer>
        <StyledMainMenu
          className={clsx(showNavigationMenu && 'open')}
          aria-label={navigationAriaLabel}
          data-testid="main-menu"
        >
          <StyledMainMenuItems>
            {sectionNavigationItems.map((mainMenuItem, menuItemIndex: number) => (
              <StyledMainMenuItem key={`main-menu-item-${menuItemIndex}`}>
                <span onClick={() => setSelectedMenuIndex(menuItemIndex)}>
                  <Button
                    isLink={!mainMenuItem.sectionNavigationSubItems.length}
                    href={
                      // eslint-disable-next-line no-script-url
                      mainMenuItem.sectionNavigationSubItems.length ? 'javascript:void(0)' : mainMenuItem.menuItemPath
                    }
                    trackingProperties={trackingProperties}
                  >
                    <span>{mainMenuItem.menuItemLabel}</span>
                    {
                      // Hide arrows if hideNavItemArrow is true and mainMenuItem doesn't have sub nav items
                      !(hideNavItemArrow && !mainMenuItem.sectionNavigationSubItems.length) ? (
                        <span
                          className={`${dir === 'ltr' ? `icon-arrow-right` : `icon-arrow-left`} sub-menu-toggler`}
                          data-testid={`sub-menu-toggler-${menuItemIndex}`}
                        ></span>
                      ) : null
                    }
                  </Button>
                </span>

                {mainMenuItem.sectionNavigationSubItems.length ? (
                  <StyledSubMenuWithBackCta
                    className={clsx(selectedMenuIndex === menuItemIndex && 'open')}
                    data-testid={`sub-menu-${menuItemIndex}`}
                  >
                    <StyledBackCtaContainer>
                      <StyledBackCta onClick={() => setSelectedMenuIndex(null)}>
                        <span
                          className={dir === 'ltr' ? `icon-back-arrow-cropped` : `icon-forward-arrow-cropped`}
                        ></span>
                      </StyledBackCta>
                    </StyledBackCtaContainer>
                    <StyledSubMenuContainer>
                      <StyledMainMenuTitle>{mainMenuItem.menuItemLabel}</StyledMainMenuTitle>
                      <StyledSubMenu>
                        {mainMenuItem.sectionNavigationSubItems.map((subMenuItem, subMenuItemIndex) => (
                          <StyledSubMenuItem
                            className={clsx(
                              mainMenuItem.menuItemLabel === activeMenuItem.menuLabel &&
                                subMenuItem.subMenuItemLabel === activeMenuItem.subMenuLabel &&
                                'selected'
                            )}
                            key={`sub-menu-item-${menuItemIndex}${subMenuItemIndex}`}
                            data-testid={`sub-menu-item-${menuItemIndex}${subMenuItemIndex}`}
                          >
                            <Button
                              isLink={true}
                              href={subMenuItem.subMenuItemPath}
                              custom_click_track_value={`${mainMenuItem.menuItemLabel} | ${subMenuItem.subMenuItemLabel} |internal`}
                              trackingProperties={trackingProperties}
                            >
                              {subMenuItem.subMenuItemLabel}
                            </Button>
                          </StyledSubMenuItem>
                        ))}
                      </StyledSubMenu>
                    </StyledSubMenuContainer>
                  </StyledSubMenuWithBackCta>
                ) : null}
              </StyledMainMenuItem>
            ))}
          </StyledMainMenuItems>
        </StyledMainMenu>
      </StyledNavigationMenu>
    </StyledNavigationMenuWrapper>
  );
};
